/**
 * Labstep
 *
 * @module components/Chemical/Form/fields
 * @desc Form Fields for Chemical
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import rules from 'labstep-web/services/validation/rules';

export const fieldPurityName = 'purity';

export const fieldPurity: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  fieldLabel: 'Purity',
  name: fieldPurityName,
  validation: rules.chemical.purity,
  // This is so that it doesn't turn into
  // a number but statys as string
  skipTransform: true,
};

export const fieldEquivalenceName = 'equivalence';

export const fieldEquivalence: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  fieldLabel: 'Equivalence',
  name: fieldEquivalenceName,
  validation: rules.chemical.equivalence,
};

export const fieldMolarAmountName = 'molar_amount';

export const fieldMolarAmount: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  fieldLabel: 'Molar Amount',
  name: fieldMolarAmountName,
  validation: rules.chemical.molar_amount,
};
